/// ////////////////////////////////////////////////////////////
/// ////////////////////// Russian /////////////////////////////
/// ////////////////////////////////////////////////////////////
import React from "react";

import { DASH_LINKS } from "@const/AppCardLinks";

export const data: Record<string, React.ReactNode> = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <b>Процесс входа в родительский портал EngagED (Внутренний/Внешний)</b>,
    Interrupt_p1: (
        <>
            Чтобы войти в родительский портал EngagED, вы объедините ваше{" "}
            <b>имя пользователя в родительском портале Infinite Campus</b> (внешний родитель: имя пользователя,
            созданное вами при настройке аккаунта) <u>и</u> <b>@p.dcsdk12.org</b>. Например: если ваше имя пользователя
            в Infinite Campus - <b>jsmith</b>, вы введете <b>jsmith@p.dcsdk12.org</b> в качестве вашего адреса
            электронной почты на следующем экране входа. Ваш <b>пароль</b> тот же, который вы используете для доступа к
            Infinite Campus (внешний родитель: пароль, созданный вами при настройке аккаунта).
        </>
    ),
    Interrupt_p2: (
        <>
            <b>Если вы забыли свои учетные данные для входа в DCSD</b>:<br />
            Используйте эти ссылки, чтобы
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/forgotuserid.jsf"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                восстановить свое имя пользователя
            </a>{" "}
            и/или{" "}
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/kiosk.jsf"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                сбросить свой пароль
            </a>
            {"."}
        </>
    ),
    Interrupt_p3: (
        <>
            <b>Если вы выполнили вышеуказанные шаги и продолжаете испытывать трудности, пожалуйста, свяжитесь с нами</b>
            :<br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - английский
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - испанский
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - китайский
            </a>
            <br />
            Центр технической поддержки по номеру <b>303.387.0001</b>
        </>
    ),
    Interrupt_note:
        "ПРИМЕЧАНИЕ: Сотрудники округа, которые в настоящее время являются родителями, должны следовать приведенным выше инструкциям, используя окно браузера в режиме инкогнито или приватный режим и/или другой браузер.",
    Interrupt_submit: "Перейти к входу",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Добро пожаловать,",
    Main_Nav_HelpfulLinks: "Полезные ссылки",
    Main_Nav_LogOut: "Выйти",
    Main_Nav_HelpfulLinks_LI_s1: "Связаться с медсестрой моего(-их) ученика(-ов)",
    Main_Nav_HelpfulLinks_LI_s2: "Академические календари",
    Main_Nav_HelpfulLinks_LI_s3: "Ресурсы для родителей",
    Main_Nav_HelpfulLinks_LI_s4: "Маршруты автобусов",
    Main_Nav_HelpfulLinks_LI_s5: "Онлайн-платежи",
    Main_Nav_HelpfulLinks_LI_s6: "Меню обедов",
    Main_Nav_Exit: "ВЫХОД",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_Add: "Добавить",
    Global_Add_New_Student: "Добавить нового студента",
    Global_Add_New_Student_For_Open_Enrollment: "Добавить нового студента для открытой записи",
    Global_BackToDashboard: "Вернуться к панели управления",
    Global_Dashboard: "Панель управления",
    Global_Faq: "Часто задаваемые вопросы",
    Global_Close: "Закрыть",
    Global_Completed: "Завершено",
    Global_Currently_Unavailable: "В настоящее время недоступно",
    Global_InProgress: "В процессе",
    Global_GoTo: "Перейти к",
    Global_Loading: "Пожалуйста, подождите, пока мы собираем информацию о вашем учащемся ...",
    Global_MoreInfo: "Подробнее",
    Global_No_Student_1: "Добро пожаловать на родительский портал EngagED",
    Global_No_Student_2: "К сожалению, нам не удалось найти студентов, связанных с вашей учетной записью.",
    Global_No_Student_External: (
        <>
            Если вы подаете заявление на открытую запись, нажмите кнопку &ldquo;{""}
            <strong>Добавить нового студента</strong>&rdquo;, чтобы добавить своего ученика. Если вы подаете заявление
            на нескольких учащихся, вы будете добавлять каждого учащегося по отдельности.
        </>
    ),
    Global_No_Student_Guardian: (
        <>
            Если вы не видите своих учащихся, а они в настоящее время зачислены в школу DCSD, обратитесь в Центр
            поддержки IT по телефону <strong>303-387-0001</strong>. Пожалуйста, используйте кнопку &ldquo;{""}
            <strong>Добавить нового студента</strong>&rdquo;, чтобы добавить учащегося, только если он в настоящее время
            не зачислен в школу DCSD, и вы подаете заявление на открытую запись.
        </>
    ),
    // Global_No_Student_Guardian2: (
    //     <>
    //         Please only use the &ldquo;<strong>Add New Student</strong>
    //         &rdquo; button to add your student if they are not currently enrolled in a DCSD school and you are applying
    //         for Open Enrollment.
    //     </>
    // ),
    Global_Notice_Ae: "Освобождения от оценки будут доступны", // <some date>
    Global_Notice_Bus: "Транспорт будет доступен", // <some date>
    Global_Notice_Check_Back: "Пожалуйста, зайдите позже.",
    Global_Notice_Oe: "Открытая запись будет доступна", // <some date>
    Global_NotStarted: "Не начато",
    Global_Open: "Открыто",
    Global_OpenFrom: "Открыто с ", // [DATE] - [DATE]
    Global_Status: "Статус",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "Панель управления опекуна DCSD",
    Breadcrumb_Back: "Портал для родителей DCSD EngagED",
    Breadcrumb_EPR: "Архивная информация об EPR DCSD",
    Breadcrumb_Translations: "Переводы экспериментальные",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Broadcast ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    Broadcast_Title: "Смотря вперёд:",
    Broadcast_Message: (
        <>
            Обращаем ваше внимание, что все родительские инструменты DCSD, включая Открытую регистрацию, будут
            отключены/недоступны в <strong>субботу, 22 ноября</strong> и <strong>воскресенье, 23 ноября</strong>, пока
            команда IT DCSD будет выполнять критически важную миграцию центра обработки данных.
        </>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////////// EPR /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    EPR_Failure1: "К сожалению, нам не удалось получить EPR PDF для студента за",
    EPR_Failure2: "При обращении в округ за поддержкой, пожалуйста, предоставьте следующую информацию:",
    EPR_NoData: "Для студента не найдено исторических EPR.",
    EPR_Success: "PDF-файл EPR успешно получен для студента.",
    EPR_Title: "Архивированные ресурсы EPR",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// No Apps /////////////////////////////
    /// /////////////////////////////////////////////////////////
    NoApp_Body1: "Все окна подачи заявлений в настоящее время закрыты.",
    NoApp_Body2: "Если вы считаете, что это ошибка, обратитесь за поддержкой в округ.",
    NoApp_Closed: "Закрыто",
    NoApp_Header: "Нет доступных заявлений",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Welcome Page ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Welcome_Header: "Добро пожаловать в панель опекуна DCSD",
    Welcome_Header_Alt: "Добро пожаловать на портал для вовлеченных родителей",
    Welcome_Tagline: "Сотрудничество с родителями для выбора наилучшей учебной среды для каждого ученика.",
    Welcome_p1: (
        <p className="grey-text">
            Мы помогаем семьям найти наилучший образовательный вариант для их детей.{" "}
            <a
                href="https://www.dcsdk12.org/schools-academics/schools/school-locator-map"
                rel="noreferrer"
                target="_blank"
            >
                Узнать больше
            </a>
        </p>
    ),
    Welcome_p2: (
        <p className="grey-text">
            Семьи, желающие зачислить своего ребенка в школу, отличную от школы по месту жительства, должны использовать
            этот инструмент для подачи заявки на открытую запись (Open Enrollment) в один из двух периодов открытой
            записи, ежегодно предлагаемых DCSD.{" "}
            <span className="highlight">
                Вам не нужно использовать этот инструмент открытой записи, чтобы остаться в школе{" "}
                <b>текущего зачисления</b>.
            </span>
        </p>
    ),
    Welcome_h5_1: (
        <h5 className="grey-text">
            <a
                href="https://docs.google.com/document/d/1sr3ARzZGUmmJdNSjlWnLM0QWj8ipKHJb3RkwLr72_P0/edit"
                rel="noreferrer"
                target="_blank"
            >
                Нажмите здесь
            </a>{" "}
            для получения пошаговых инструкций по использованию инструмента.
        </h5>
    ),
    Welcome_ImportantDates: "Важные даты/время",
    Welcome_FirstWindow: "Первый период",
    Welcome_SecondWindow: "Второй период",
    Welcome_ul_li1a:
        "Первый раунд открытой записи НЕ является принципом «первым пришел — первым обслужен»; у вас есть время до ", // [DATE]
    Welcome_ul_li1b: " для завершения этого процесса.",
    Welcome_ul_li2a: "Для первого раунда вы можете изменять свой выбор в заявке на открытую запись в любое время до ", // [DATE]
    Welcome_ul_li3: "Школы будут делать предложения семьям в зависимости от наличия мест.",
    Welcome_ul_li4a: "Предложения будут видны вам только после ", // [DATE]
    Welcome_ul_li4b: (
        <>
            Вы можете снова войти в <a href={DASH_LINKS.guardian}>Родительский портал EngagED</a> начиная с
        </>
    ), // [DATE]
    Welcome_ul_li4c: " , чтобы проверить любые полученные вами предложения.",
    Welcome_ul_li5a: "У вас есть время до ", // [DATE]
    Welcome_ul_li5b: (
        <>
            , чтобы принять предложение об открытой записи от школы через{" "}
            <a href={DASH_LINKS.guardian}>Родительский портал EngagED</a>.
        </>
    ),
    Welcome_ul_li6a:
        "Если ваша заявка на открытую запись не будет принята ни одной школой, или вы не вошли в систему и не приняли свое предложение, вы будете автоматически помещены в список ожидания второго раунда открытой записи, который действует с ", // [DATE RANGE]
    Welcome_Before_You_Begin: "ПЕРЕД НАЧАЛОМ",
    Welcome_Before_You_Begin_Body: (
        <>
            <div className="grey-text" style={{ fontWeight: "bold" }}>
                Если ваш сын или дочь когда-либо учились в школе DCSD, у вас уже есть имя пользователя и пароль для
                учетной записи родительского портала. Пожалуйста,{" "}
                <span className="text-danger">
                    <u>НЕ</u>
                </span>{" "}
                создавайте новую учетную запись, так как это потенциально повлияет на открытую запись вашего учащегося.
                Если вы забыли данные своей учетной записи родительского портала, обратитесь в текущую школу DCSD или в
                офис Choice Programming для получения доступа к родительскому порталу.
            </div>
            <h5 className="mt-3">Вниманию родителей/опекунов:</h5>
            <div className="grey-text">
                Процесс входа в родительский портал EngagED недавно изменился.{" "}
                <b>
                    Теперь при входе в родительский портал EngagED родители/опекуны должны добавлять{" "}
                    <u>@p.dcsdk12.org</u> после своего текущего имени пользователя
                </b>
                {". "}
                Например, если раньше вы входили с именем пользователя absmith, теперь вы будете использовать
                absmith@p.dcsdk12.org в качестве имени пользователя вместе с вашим окружным паролем, который не
                изменился.
            </div>
            <div className="grey-text mt-3">
                Если вам нужно изменить окружной пароль и/или управлять своей учетной записью, вы можете сделать это на
                сайте DCSD{" "}
                <a
                    href="https://www.dcsdk12.org/parents-students/resources/parent-it-support/password-reset"
                    rel="noreferrer"
                    target="_blank"
                >
                    здесь
                </a>
                . Если у вас возникнут трудности со входом в EngagED с использованием нового процесса, описанного выше,
                обратитесь в ИТ-отдел DCSD, нажав{" "}
                <a
                    href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                    rel="noreferrer"
                    target="_blank"
                >
                    здесь
                </a>{" "}
                или позвонив по телефону 303-387-0001.
            </div>
        </>
    ),
    Welcome_InfoFooter: (
        <>
            <em>
                Для получения дополнительной информации, пожалуйста, свяжитесь с офисом{" "}
                <strong>Choice Programming</strong> по электронной почте:
            </em>{" "}
            <a href="mailto:open-enrollmentusergroup@dcsdk12.org">open-enrollmentusergroup@dcsdk12.org</a>.
        </>
    ),
    Welcome_NotAvailable: "Процесс открытой записи на текущий учебный год пока недоступен.",
    Welcome_PreschoolInfo: "Информация о детском саде/дошкольном учреждении",
    Welcome_Note: "ПРИМЕЧАНИЕ",
    Welcome_NoSupport: "Это приложение не поддерживает подачу заявок в дошкольные учреждения DCSD.",
    Welcome_PreschoolsLink: (
        <>
            Для дошкольных учреждений DCSD{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/preschool" rel="noreferrer" target="_blank">
                <strong>нажмите на эту ссылку</strong>.
            </a>
        </>
    ),
    Welcome_PreschoolEnrollment: (
        <>
            Родители, желающие зачислить своих трех- и четырехлетних детей в дошкольные учреждения округа, не проходят
            процедуру открытой записи. Регистрация в дошкольные учреждения будет проходить в начале января. Перейдите по
            этой{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/kindergarten" rel="noreferrer" target="_blank">
                <strong>ссылке</strong>
            </a>{" "}
            для получения дополнительной информации.
        </>
    ),
    Welcome_CharterSchoolInfo: "Информация о чартерных школах (Charter School)",
    Welcome_CharterSchoolInclude: (
        <>
            <h5>Следующие чартерные школы будут использовать этот инструмент в этом году:</h5>
            <a
                href="https://www.dcsdk12.org/schools_academics/schools/charter_schools"
                rel="noreferrer"
                target="_blank"
            >
                <u>
                    Пожалуйста, свяжитесь напрямую со всеми другими чартерными школами, чтобы узнать больше о вариантах
                    зачисления в чартерные школы.
                </u>
            </a>
            <ul className="charter-school-li">
                <li>
                    <i>Aspen View Academy</i>
                </li>
                <li>
                    <i>Ben Franklin Academy</i>
                </li>
                <li>
                    <i>Challenge to Excellence</i>
                </li>
                <li>
                    <i>DCS Montessori Charter</i>
                </li>
                <li>
                    <i>Leman Academy of Excellence</i>
                </li>
                <li>
                    <i>Parker Performing Arts School</i>
                </li>
                <li>
                    <i>Platte River Academy</i>
                </li>
                <li>
                    <i>SkyView Academy</i>
                </li>
                <li>
                    <i>World Compass Academy</i>
                </li>
            </ul>
        </>
    ),
    Welcome_TransportationInfo: "Информация о транспорте",
    Welcome_TransportationBody:
        "Транспортировка для учащихся-резидентов, получивших разрешение посещать школу или программу за пределами их района проживания, обеспечивается их родителем/опекуном.",
    Welcome_GeneralInfo: "Общая информация",
    Welcome_GeneralInfo_ul2_li1:
        "После отправки вашего запроса вам будет отправлено электронное письмо с подтверждением.",
    Welcome_GeneralInfo_ul2_li3:
        "Второй раунд открытой записи осуществляется по принципу «первым пришел — первым обслужен». Учащиеся, подающие заявку на открытую запись только во втором раунде, помещаются в список ожидания после тех, кто уже находится в списке ожидания с первого раунда.",
    Welcome_GeneralInfo_ul2_li4: (
        <>
            Если вы зачислены по открытой записи в школу по месту жительства или посещаете чартерную школу, но хотели бы
            вернуться в школу по месту жительства, связанную с вашим адресом, на следующий учебный год, вы должны подать{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                заявление о намерении вернуться
            </a>{" "}
            <b>до</b>
        </>
    ), // [DATE],
    Welcome_GeneralInfo_li5: (
        <>
            Если вы переезжаете в пределах округа, но хотели бы остаться в своей текущей школе, вы можете сделать это,
            подав заявление о{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                намерении остаться
            </a>{" "}
            в любое время.
        </>
    ),
    Welcome_Start_Here: "Начать здесь",
    Welcome_New_To_District: "Вы новичок в округе?",
    Welcome_No: "Нет",
    Welcome_Yes: "Да",
    Welcome_U_And_P: "У вас есть имя пользователя и пароль для родительского портала EngagED?",
    Welcome_Log_In: "Войти",
    Welcome_Contact_Choice_Programming:
        "Пожалуйста, свяжитесь с текущей школой ученика для получения помощи в создании учетной записи родительского портала DCSD.",
    Welcome_Create_Account: "Создать новую учетную запись",
    Welcome_Caution:
        "* Внимание: Если у вас уже есть учащийся в округе, но у вас возникли проблемы со входом в родительский портал EngagED, НЕ создавайте новую учетную запись, так как это может привести к АННУЛИРОВАНИЮ вашего заявления на открытую запись! Если вам нужна помощь со входом в существующую учетную запись родительского портала EngagED, обратитесь в вашу нынешнюю школу DCSD или в офис «Выбор программ».",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Marquee /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Marquee_Grade: "Класс",
    Marquee_School: "Школа",
    Marquee_Address: "Адрес",
    Marquee_NewStudent: "Новый ученик",
    Marquee_NotAvailable: "Недоступно",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Open Enrollment App /////////////////////
    /// /////////////////////////////////////////////////////////
    OEApp_Header: "Открытая запись (Open Enrollment)",
    OEApp_Btn1: "Начать открытую запись",
    OEApp_Btn2: "Управление выбором школ",
    OEApp_Btn3: "Просмотр информации об ученике",
    OEApp_Btn4: "Редактировать информацию об ученике",
    OEApp_Btn5: "Выберите варианты школ",
    OEApp_Btn6: "Открытая регистрация",
    OEApp_Btn7: "Просмотреть варианты школ",
    OEApp_Btn8: "Просмотр Статуса Предложения Школы",
    OEApp_Btn9: "Просмотреть Предложения Школы",
    OEApp_Schools: "Сделанные выборы школ",
    OEApp_School: "Сделанный выбор школы",
    OEApp_NoSchools: "Выбор школы не сделан",
    OEApp_1School: "1 выбор школы сделан",
    OEApp_MoreSchools: "выборов школы сделано",
    OEApp_SchoolsMakingOffers: "Школы Делают Предложения",
    OEApp_SchoolsFinalizingOffers: "Школы завершают оформление предложений",
    OEApp_Body:
        "Процесс подачи заявок для родителей на рассмотрение зачисления их ученика(ов) в школы по месту жительства и чартерные школы DCSD.",
    OEApp_Round1: "Раунд 1",
    OEApp_Round2: "Раунд 2",
    OEApp_RoundClosed: "Раунд 1 закрыт. Пожалуйста, вернитесь для Раунда 2, начиная с ", // [DATE]
    OEApp_SchoolChoices: "Выбор школ",
    OEApp_RequestStatus: "Статус заявки",
    OEApp_LanguageChoice: "Выбор языка",
    OEApp_KinderChoice: "Выбор детского сада",
    OEApp_LanguageOffer: "Предложение по языку",
    OEApp_KinderOffer: "Предложение по детскому саду",
    OEApp_FullDay: "Полный день",
    OEApp_HalfDayPM: "Пол дня (после обеда)",
    OEApp_HalfDayAM: "Пол дня (до обеда)",
    OEApp_Spanish: "Испанский",
    OEApp_Mandarin: "Мандаринский",
    OEApp_French: "Французский",
    OEApp_NotEligible: (
        <>
            Согласно дате рождения учащегося,{" "}
            <span className="age">возраст учащегося выходит за пределы диапазона для открытой регистрации</span>.
            Пожалуйста, свяжитесь с отделом выбора программ (Choice Programming), чтобы обсудить конкретные
            обстоятельства и/или варианты открытой регистрации.
        </>
    ),
    OEApp_Ineligible: "Не соответствует требованиям",
    OEApp_NewStudent: "Новый ученик",
    OEApp_ACCEPT_OFFER: "Предложение принято",
    OEApp_CANCELLED_REQUEST: "Заявка отменена",
    OEApp_CHANGED_ENROLLMENT: "Отчислен",
    OEApp_CHOICE_CREATED: "Выбор школы создан",
    OEApp_CHOICE_INCOMPLETE: "Выбор не завершен",
    OEApp_DENY_OFFER: "Предложение отклонено",
    OEApp_DENY_REQUEST: "Заявка отклонена",
    OEApp_ENROLLED: "Зачислен",
    OEApp_INVALID: "Недействительно",
    OEApp_MAKE_OFFER: "Предложение сделано",
    OEApp_MAKE_OFFER_PENDING: "Ожидание предложения",
    OEApp_NO_RESPONSE: "Нет ответа",
    OEApp_WAIT_LIST: "В списке ожидания",
    OEApp_REQUEST: "Заявка подана",
    OEApp_UNENROLLED: "Отчислен",
    OEApp_UNAVAILABLE: "Недоступно",
    /// /////////////////////////////////////////////////////////
    /// ///////////// Express Check-In App //////////////////////
    /// /////////////////////////////////////////////////////////
    ECApp_Header: "Экспресс-регистрация (Express Check-In)",
    ECApp_Btn1: "Экспресс-регистрация",
    ECApp_Body:
        "Ежегодный процесс регистрации учащихся для родителей для обновления и/или проверки текущей информации об адресе домохозяйства, согласии на использование медиафайлов, контактах для экстренной связи, состоянии здоровья и многом другом.",
    /// ////////////////////////////////////////////////////////
    /// ///////// Elementary Progress Report App ///////////////
    /// ////////////////////////////////////////////////////////
    EPRApp_Body: "Информация об успеваемости учеников местных начальных школ (дважды в год)",
    EPRApp_NotReady:
        "Табель успеваемости вашего ученика еще не готов. Пожалуйста, обратитесь в школу вашего ученика за дополнительной информацией.",
    EPRApp_NotReleased: "Не опубликовано",
    EPRApp_Coming_Soon: "Скоро будет",
    EPRApp_Available: "Табель успеваемости не доступен. Пожалуйста, повторите попытку, начиная с ", // [some variable dateString]
    EPRApp_IsAvailable: "Табель успеваемости доступен",
    EPRApp_NotAvailable: "Недоступно",
    EPRApp_Header: "Табель успеваемости начальной школы",
    EPRApp_Btn1: "Просмотреть последний табель",
    EPRApp_Btn2: "Просмотреть архивные табели",
    EPRApp_Semester: "Семестр",
    EPRApp_1stSemester: "Первый семестр",
    EPRApp_2ndSemester: "Второй семестр",
    EPRApp_SurveyLink: "Заполнить опрос EPR для родителей",
    EPRApp_SurveyHeadline: "Опрос для родителей EPR",
    EPRApp_SurveyDescription: "Заранее благодарим вас за отзыв об отчёте об успеваемости вашего ученика.",
    /// ////////////////////////////////////////////////////////
    /// /////////// Assessment Excusals App ////////////////////
    /// ////////////////////////////////////////////////////////
    AEApp_Body: "Управление запросами на отказ от оценок.",
    AEApp_Header: "Освобождения от оценок",
    AEApp_Excusal: "Освобождение",
    AEApp_Excusals: "Освобождения",
    AEApp_NoExcusals: "Нет освобождений",
    AEApp_MoreExcusals: "освобождений",
    AEApp_Btn1: "Освобождение от оценки",
    /// ////////////////////////////////////////////////////////
    /// /////////////// Transportation App /////////////////////
    /// ////////////////////////////////////////////////////////
    BusApp_Body1:
        "Каждый пассажир должен предъявить водителю действующий проездной. Стоимость проезда будет выставляться ежеквартально за каждую поездку.",
    BusApp_Body2: "Подать заявление на получение проездного билета",
    BusApp_Header: "Транспорт",
    BusApp_Btn1: "Транспорт",
    BusApp_BusPass: "Проездной на автобус выдан",
    BusApp_NotIssued: "Проездной билет не выдан",
    BusApp_NoBusPass: "Вы можете запросить проездной билет и получить дополнительную информацию о транспорте.",
    BusApp_NotRiding: "Не пользуется автобусом",
    BusApp_NotRidingReason1: "Вы указали, что ", // [NAME]
    BusApp_NotRidingReason2: " не будет пользоваться автобусом в этом году.",
    BusApp_NotRidingReason3: "Вы указали, что ученик не будет ездить на автобусе в этом году",
    BusApp_Processing: "Обработка проездного на автобус",
    BusApp_AnnualOffer: "Предложение годового проездного до ", // [DATE]
    BusApp_Annual: "В предыдущем сеансе вы выбрали годовую тарификацию.",
    BusApp_Quarterly: "Вы выбрали ежеквартальную оплату. Вы можете выбрать годовую оплату до ", // [DATE]
    BusApp_BusPassIssued: "Проездной билет вашего учащегося был выдан.",
    BusApp_BusPassIssued2: (
        <>
            Если проездной билет поврежден или утерян, можно запросить его замену через{" "}
            <a
                className="anchor"
                href="https://www.onflo.com/Lets-Talk/FormBuilder/#/Dialogue?k=PG7KK3Z6DLT@WK3Z6DLT@MDLT@DY4N3T5LT@LDLT@NDLT"
                rel="noreferrer"
                target="_blank"
            >
                Onflo
            </a>
            {"."}
        </>
    ),
    BusApp_BusPassProcessing:
        "Ваше заявление на получение проездного билета все еще обрабатывается. Пожалуйста, зайдите позже.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Loading Messages ////////////////////////
    /// /////////////////////////////////////////////////////////
    Loading_1: "Загрузка открытой записи",
    Loading_2: "Загрузка экспресс-регистрации",
    Loading_3: "Загрузка отчета об успеваемости",
    Loading_4: "Загрузка освобождений от оценок",
    Loading_5: "Загрузка транспорта",
    Loading_6: "Загрузка опроса",
    Loading_7: "Загрузка широковещательного сообщения",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Open Enrollment Pending & Status ////////
    /// /////////////////////////////////////////////////////////
    OE_Pending_Desc_Pre: "Открытая запись на ",
    OE_Pending_Desc_Post:
        " учебный год еще не началась. Мы приглашаем будущие семьи и внешних опекунов ознакомиться со школами DCSD и подготовиться к предстоящему периоду записи.",
    OE_Pending_Begins: "Открытая запись начинается ",
    OE_Countdown_Opens_In: "Открывается через ",
    OE_Countdown_Day: "день",
    OE_Countdown_Days: "дней",
    OE_Explore_Schools_Title: "Изучить школы DCSD",
    OE_Explore_Schools_Desc:
        "Узнайте о районных, чартерных и альтернативных школах округа Дуглас, чтобы найти наилучшие условия обучения для вашего ученика.",
    OE_Explore_Schools_Btn: "Изучить варианты школ →",
    OE_Info_Title: "Информация об открытой записи",
    OE_Info_Desc:
        "Узнайте о сроках открытой записи, процессах подачи заявлений, уровнях приоритетного зачисления и важных сроках округа.",
    OE_Info_Btn: "Посмотреть правила записи →",
    OE_Help_Footer_Title: "Ваш ученик уже учится в DCSD?",
    OE_Help_Footer_Desc:
        " Если ваш ученик в настоящее время посещает школу DCSD, у вас уже есть учетная запись родительского портала. Пожалуйста, войдите в систему, используя свои учетные данные опекуна, или обратитесь в школу вашего ученика за помощью.",
    OE_Guardian_No_Students_IT_Help:
        "Если вы не видите своего ученика (учеников), и они в настоящее время зачислены в школу DCSD, обратитесь в Центр поддержки IT по телефону ",
    OE_Notice_Header: "Подаете заявление на открытую запись?",
    OE_Notice_Begins_Pre: "Открытая запись на ",
    OE_Notice_Begins_Mid: " учебный год начнется ",
    OE_Notice_Subtext:
        "Как только откроется окно записи, вверху появится кнопка «Добавить нового ученика» для подачи вашего заявления.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Error Messages //////////////////////////
    /// /////////////////////////////////////////////////////////
    Error_UserDetails_Title: "Данные пользователя недоступны",
    Error_UserDetails_Sub: (
        <>
            Возникла проблема при получении информации о вашей учетной записи из нашей системы.
            <br />
            Приносим извинения за доставленные неудобства
        </>
    ),
    Error_UserDetails_Sync_Msg:
        "Если вы являетесь действующим опекуном DCSD, для информации о вашей учетной записи может потребоваться дополнительное устранение неполадок.",
    Error_UserDetails_Contact_Pre: (
        <>
            Пожалуйста, обратитесь в <strong>Центр технической поддержки</strong> по телефону{" "}
            <strong style={{ color: "#0669B3" }}>303-387-0001</strong> для получения дальнейшей помощи.
        </>
    )
    /// /////////////////////////////////////////////////////////
};
